import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import SvgIcon from 'li-components/lib/SvgIcon'
import vars from 'li-components/lib/styles'

const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 3.75rem;
  background-color: ${vars.white};
  border: 1px solid ${vars.inputBorderColor};
  border-radius: ${vars.inputBorderRadius};
  font-weight: 400;
`

const Icon = styled(SvgIcon).attrs({
  name: 'search-1',
})`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 4rem;
  height: 100%;
  padding: 0 1rem;
  margin-left: auto;

  svg {
    fill: ${vars.grayLight};
    width: 2rem;
    height: 2rem;
  }
`

const Input = styled.input`
  width: 75%;
  padding-left: 1rem;
  border: 0;

  &:focus {
    outline: 0;
  }

  &::placeholder {
    color: ${vars.grayLight};
  }
`

const Search = ({ value, onChange, onPressEnter, className, ...rest }) => (
  <Container className={className}>
    <Input
      type="text"
      value={value}
      onChange={onChange}
      onKeyPress={e => {
        if (e.key === 'Enter' && onPressEnter) {
          onPressEnter()
        }
      }}
      {...rest}
    />
    <Icon />
  </Container>
)

Search.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  onPressEnter: PropTypes.func,
  className: PropTypes.string,
}

export default Search



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/help/components/SearchInput.js